import { createFileRoute } from '@tanstack/react-router';

import { LeadershipPage } from '../../features/manager-leadership/components/LeadershipPage';

export const Route = createFileRoute('/_onboarding/leadership')({
  component: LeadershipRoute,
});

function LeadershipRoute() {
  return <LeadershipPage />;
}
